import { createSlice } from '@reduxjs/toolkit'
import api from '../../Core/Services/Api'
import { ofType } from 'redux-observable'
import { from } from 'rxjs'
import { mergeMap } from 'rxjs/operators'
import { manageMapEpicResponse } from '../../Common/Utils/Api'
import { apiMapSlice } from '../../Common/Utils/Redux'

const emptyData = []

// reducer
const dtcsSlice = createSlice(apiMapSlice('dtcs'))

export const { request, success, failure } = dtcsSlice.actions

export default dtcsSlice.reducer

export const selectDtcs = (state) => state.dtcs
export const selectDtcsData = (id) => (state) =>
  state.dtcs.data[id]?.value || emptyData
export const selectDtcsFetching = (id) => (state) => state.dtcs.fetching[id]
export const selectDtcsFetched = (id) => (state) => state.dtcs.fetched[id]

// side effects
export const fetchDtcsEpic = (action$) =>
  action$.pipe(
    ofType('dtcs/request'),
    mergeMap((action) => {
      return from(api.configurations.getAllDtcs(action.payload)).pipe(
        ...manageMapEpicResponse(
          action.payload, // the map id
          success,
          failure,
          'configurator:errors.FetchDtcsError',
          true,
        ),
      )
    }),
  )
